import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../storages/auth";
import LayoutsTopbar from "./Topbar";
import Container from "./Container";
import LayoutsFooter from "./Footer";
import { fetchPengumuman } from "../../api";
import ModalPrimary from "../ModalPrimary";
import ModalWarning from "../ModalWarning";

const LayoutsMain = (props) => {
  const { children } = props;

  // const title = useRecoilValue(titleState);
  // const user = useRecoilValue(userState);
  const token = useRecoilValue(tokenState);

  const [itemsPem, setItemsPem] = useState([]);
  const [currentPem, setCurrentPem] = useState(0);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchPengumuman("all", token);
      // console.log(res);
      // console.log(res.data.pengumuman);
      setItemsPem(res.data.pengumuman);
      setCurrentPem(0);
      setShowModal(true); // Menampilkan modal pertama kali
    };

    fetchData();
  }, [token]);

  // const nextPengumuman = () => {
  //   // setCurrentPem(prevIndex => prevIndex + 1);
  //   // setShow(false);
  //   setShowStates(prevStates => prevStates.map((state, index) => index === currentPem ? false : state));
  //   setCurrentPem(prevIndex => prevIndex + 1);
  // }
  const nextPengumuman = () => {
    if (currentPem < itemsPem.length - 1) {
      setCurrentPem(prevIndex => prevIndex + 1);
      setShowModal(true);
    } else {
      setShowModal(false); // Menutup modal setelah data terakhir
    }
  };

  // const handleCloseModal = () => {
  //   setShowModal(false);
  // };

  const showPengumuman = itemsPem[currentPem];



  // const [show, setShow] = useState(true);

  //   const openModal = () => {
  //       setShow(true);
  //   }
  //   const closeModal = () => {
  //       setShow(false);
  //   }

  const [modalMendadak, setModalMendadak] = useState(true);

  return (
    <>
      {showPengumuman && (
        currentPem % 2 === 0 ? (
          <ModalPrimary 
          show={showModal}
          onClose={nextPengumuman}
          judul={showPengumuman && showPengumuman.judul}
          deskripsi={showPengumuman && showPengumuman.isi}
          dari={showPengumuman && showPengumuman.dari.split('-').reverse().join('-')}
          sampai={showPengumuman && showPengumuman.sampai.split('-').reverse().join('-')}
          file={showPengumuman && showPengumuman.file}
        />
        ) : (
          <ModalWarning 
            show={showModal}
            onClose={nextPengumuman}
            judul={showPengumuman && showPengumuman.judul}
            deskripsi={showPengumuman && showPengumuman.isi}
            dari={showPengumuman && showPengumuman.dari.split('-').reverse().join('-')}
            sampai={showPengumuman && showPengumuman.sampai.split('-').reverse().join('-')}
            file={showPengumuman && showPengumuman.file}
          />
        )
      )}

      <ModalPrimary
        show={modalMendadak}
        onClose={() => setModalMendadak(false)}
        judul="Kepada Yth. Seluruh Mahasiswa D1 dan D2 Semester Akhir."
      >
        <br />
        <p className="mb-3">
          Dalam rangka persiapan pelaksanaan Ujian Tugas Akhir (TA) dan Pendaftaran
          Wisuda, kami mengimbau kepada seluruh mahasiswa semester akhir untuk segera
          menyelesaikan kewajiban administrasi keuangan yang masih tertunggak,
          meliputi:
        </p>

        <ul className="mb-3">
          <li>Angsuran SPP yang belum lunas.</li>
          <li>Biaya Sertifikasi yang belum dibayarkan.</li>
        </ul>

        <p className="mb-3">
          Kami menyarankan agar pembayaran dilakukan sesegera mungkin guna
          menghindari penumpukan beban pembayaran menjelang pelaksanaan Ujian Tugas
          Akhir dan proses pendaftaran wisuda.
        </p>

        <p className="mb-2">
          Perlu diperhatikan bahwa mahasiswa yang masih memiliki tunggakan SPP maupun
          biaya sertifikasi berisiko tidak dapat:
        </p>

        <ul className="mb-3">
          <li>Mengikuti Ujian Tugas Akhir (TA).</li>
          <li>Melakukan pendaftaran Wisuda.</li>
          <li>
            Mengurus administrasi kelulusan lainnya sampai seluruh kewajiban keuangan
            diselesaikan.
          </li>
        </ul>

        <p className="mb-3">
          Oleh karena itu, kami mengharapkan kerja sama seluruh mahasiswa untuk segera
          melakukan pembayaran dan memastikan status administrasi dalam keadaan aktif
          serta tidak memiliki tunggakan.
        </p>

        <p className="mb-3">
          Apabila telah melakukan pembayaran, harap segera melakukan konfirmasi
          kepada bagian keuangan kampus.
        </p>

        <p className="mb-0">
          Demikian pengumuman ini disampaikan. Atas perhatian dan kerja sama yang
          baik, kami ucapkan terima kasih.
        </p>
      </ModalPrimary>
      <LayoutsTopbar />
      <Container>{children}</Container>
      <LayoutsFooter />
    </>
  );
};

export default LayoutsMain;
